import * as theme from "../theme";

import React, { useState } from "react";

import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import RateZipSlider from "../components/StyledSlider";
import Context from "../contexts/data";
import { handleRedirection } from "../util/httpHelpers";
import { formatCurrency } from "../util/regex";

const MortgageBalance = () => {
  const {
    homeValue,
    mortgageBalance,
    errorMessage,
    handleUpdateFormValue,
    navigate,
  } = React.useContext(Context);

  const [mortgageBalanceText, setMortgageBalanceText] = useState(
    formatCurrency(mortgageBalance)
  );

  const [buttonText, setButtonText] = useState("Next");

  const handleNextStep = () => {
    if (mortgageBalance > 2000000) {
      handleUpdateFormValue(
        "errorMessage",
        "Mortgage balance should be not greater than $2,000,000."
      );
      return;
    } else {
      handleUpdateFormValue("errorMessage", "");
      const ltv = (mortgageBalance * 100) / homeValue;

      // Over 50% LTV there is not enough equity left for a reverse mortgage,
      // so the borrower diverts to MRC (Paul, 2026-07-31). Was 45.
      if (ltv > 50) {
        setButtonText("Redirecting...");
        handleRedirection("ltv");
        return;
      }

      navigate("address", "Mtg Balance");
    }
  };

  const handleChange = ({ target }) => {
    const { value } = target;
    const { textMoney, intMoney } = formatCurrency(value, "both");

    setMortgageBalanceText(textMoney);
    handleUpdateFormValue("mortgageBalance", intMoney);
  };

  return (
    <Wrapper>
      <HeaderText bigger_text={"Estimated total mortgage balance"} />
      <RateZipSlider
        range={"$0 - $2,000,000"}
        min={0}
        max={2000000}
        value={mortgageBalance}
        handleChange={handleChange}
        step={50000}
      />
      <InputContainer inputClass={"genericContainer"}>
        <CustomInput
          value={"$" + mortgageBalanceText}
          errorMessage={errorMessage}
          fieldClass="numberInput"
          onChange={handleChange}
          name={"Mortgage Balance"}
          labelName={"Mortgage Balance"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} text={buttonText} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  transform: translateY(0px);
`;

export default MortgageBalance;
